import { Entry } from './entry';

Entry.displayName = 'Clickable';

export { Entry as Clickable };

export * as ClickableModel from './model';

export type { Props as ClickableProps } from './types';
